import React, { useEffect, useState } from 'react';
import { Typography, Grid, MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomDialog } from 'lib';

import { PrimaryButton } from 'lib/components/Buttons/buttons';
import AddIcon from '@mui/icons-material/Add';

import Search from 'lib/components/Search/Search';
import { PageLayout } from 'lib';
import { CustomTable } from 'lib';

import CustomTableLayout from 'lib/components/Tables/TabsLayout';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AddObjectivesModal from 'pages/Objectives/AddObjectivesModal';
import { ObjectivesAPI, UsersAPI } from 'api_darex';
import ConfirmModal from 'lib/components/Modals/ConfirmModal';
import { Helmet } from 'react-helmet';

import FilterListIcon from '@mui/icons-material/FilterList';

import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useUser } from 'hooks/useUser';
import dayjs from 'dayjs';
import { calculatePercentage, getProcentColor } from 'utils/functions';
import PercentageComponent from 'pages/Objectives/PercentageComponent';

const UserObjectives = () => {
    const { t } = useTranslation();
    const [openConfirm, setOpenConfirm] = useState(false);
    const { can, user } = useUser();
    const { id } = useParams();
    const [userData, setUserData] = useState(null);
    const [rowId, setRowId] = useState('');
    const [openFilter, setOpenFilter] = useState(false);
    const [openAddObjectives, setAddOpenObjectives] = useState(false);
    const [daciaObjectives, setDaciaObjectives] = useState([]);
    const [renaultObjectives, setRenaultObjectives] = useState([]);
    const [nissanObjectives, setNissanObjectives] = useState([]);
    const [triggerRefetch, setTriggerRefetch] = useState(false);
    const [tabName, setTabName] = useState('DACIA');
    const [search, setSearch] = useState('');
    const [filterData, setFilterData] = useState({
        startDate: new Date(),
        endDate: new Date(),
        userId: '',
    });
    const [loadingDacia, setLoadingDacia] = useState(true);
    const [loadingRenault, setLoadingRenault] = useState(true);
    const [loadingNissan, setLoadingNissan] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [currentUserObjectives, setCurrentUserObjectives] = useState([]);
    const todaysDate = dayjs().format();

    const [isSearch, setIsSearch] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [triggerSearch, setTriggerSearch] = useState(false);
    const [triggerFilter, setTriggerFilter] = useState(false);

    const getUserById = () => {
        UsersAPI.getById(id).then((res) => {
            setUserData(res.data);
        });
    };
    const getObjectivesByUserId = () => {
        ObjectivesAPI.getByUserId(id, todaysDate).then((res) => {
            setCurrentUserObjectives(res.data.content);
            setLoadingDacia(false);
            setLoadingRenault(false);
            setLoadingNissan(false);
        });
    };

    useEffect(() => {
        getUserById(id);
        getObjectivesByUserId();
    }, [id]);

    const existDacia = user?.UserBrand.map((item) => item.brandId).includes('1') ? true : false;
    const existRenault = user?.UserBrand.map((item) => item.brandId).includes('2') ? true : false;
    const existNissan = user?.UserBrand.map((item) => item.brandId).includes('3') ? true : false;

    const handleChange = (e) => {
        setFilterData({
            ...filterData,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (existDacia) {
            setActiveTab(0);
            setTabName('DACIA');
        } else if (existRenault) {
            setActiveTab(1);
            setTabName('RENAULT');
        } else if (existNissan) {
            setActiveTab(2);
            setTabName('NISSAN');
        }
    }, [existDacia, existRenault, existNissan]);

    const labelsRenault = [
        { id: 'counselor', label: t('Counselor'), minWidth: 10 },
        {
            id: 'vpDeliveries',
            label: t('VP Deliveries'),
            minWidth: 10,
        },
        {
            id: 'vuDeliveries',
            label: t('VU Deliveries'),
            minWidth: 10,
        },
        {
            id: 'totalDeliveries',
            label: t('Total Deliveries'),
            minWidth: 10,
        },
        { id: 'pfOrders', label: t('PF Orders'), minWidth: 10 },
        { id: 'pjOrders', label: t('PJ Orders'), minWidth: 10 },
        { id: 'totalOrders', label: t('Total Orders'), minWidth: 10 },

        { id: 'actions', label: t(''), minWidth: 10 },
    ];

    const labelsDacia = [
        { id: 'counselor', label: t('Counselor'), minWidth: 10 },
        {
            id: 'pfDeliveries',
            label: t('PF Deliveries'),
            minWidth: 10,
        },
        {
            id: 'pjDeliveries',
            label: t('PJ Deliveries'),
            minWidth: 10,
        },
        {
            id: 'electricDeliveries',
            label: t('Electric Deliveries'),
            minWidth: 10,
        },
        {
            id: 'electricOrders',
            label: t('Electric Orders'),
            minWidth: 10,
        },
        {
            id: 'thermicOrders',
            label: t('Thermic Orders'),
            minWidth: 10,
        },
        {
            id: 'hybridOrders',
            label: t('Hybrid Orders'),
            minWidth: 10,
        },
        { id: 'actions', minWidth: 90 },
    ];

    const labelsNissan = [
        { id: 'counselor', label: t('Counselor'), minWidth: 10 },
        {
            id: 'totalOrders',
            label: t('Total Deliveries'),
            minWidth: 10,
        },
        { id: 'actions', label: t(''), minWidth: 10 },
    ];

    const cellModifierDacia = (row, column, value) => {
        if (column.id === 'counselor') {
            return (
                <div>
                    <Typography variant="tableContent"> {row.user?.name + ' ' + row.user?.firstName}</Typography>
                </div>
            );
        }
        if (column.id === 'pfDeliveries') {
            let value = calculatePercentage(row.deliveriesPF, row.tDeliveriesPF);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.deliveriesPF === null ? '0' : row.deliveriesPF}/{row.tDeliveriesPF}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'pjDeliveries') {
            let value = calculatePercentage(row.deliveriesPJ, row.tDeliveriesPJ);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.deliveriesPJ === null ? '0' : row.deliveriesPJ}/{row.tDeliveriesPJ}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }

        if (column.id === 'electricDeliveries') {
            let value = calculatePercentage(row.electricalDeliveries, row.tElectricalDeliveries);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.electricalDeliveries === null ? '0' : row.electricalDeliveries}/{row.tElectricalDeliveries}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'electricOrders') {
            let value = calculatePercentage(row.electricalOrders, row.tElectricalOrders);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.electricalOrders === null ? '0' : row.electricalOrders}/{row.tElectricalOrders}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'thermicOrders') {
            let value = calculatePercentage(row.thermicOrders, row.tThermicOrders);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.thermicOrders === null ? '0' : row.thermicOrders}/{row.tThermicOrders}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'hybridOrders') {
            let value = calculatePercentage(row.hybridOrders, row.tHybridOrders);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.hybridOrders === null ? '0' : row.hybridOrders}/{row.tHybridOrders}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
    };

    const cellModifierRenault = (row, column, value) => {
        if (column.id === 'vpDeliveries') {
            let value = calculatePercentage(row.deliveriesVP, row.tDeliveriesVP);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.deliveriesVP === null ? '0' : row.deliveriesVP}/{row.tDeliveriesVP}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'vuDeliveries') {
            let value = calculatePercentage(row.deliveriesVU, row.tDeliveriesVU);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.deliveriesVU === null ? '0' : row.deliveriesVU} /{row.tDeliveriesVU}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }

        if (column.id === 'totalDeliveries') {
            let value = calculatePercentage(row.totalDeliveries, row.tTotalDeliveries);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.totalDeliveries}/{row.tTotalDeliveries}
                    </Typography>

                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }

        if (column.id === 'totalOrders') {
            let value = calculatePercentage(row.totalOrders, row.tTotalOrders);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.totalOrders}/{row.tTotalOrders}
                    </Typography>

                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'pfOrders') {
            let value = calculatePercentage(row.ordersPF, row.tOrdersPF);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.ordersPF === null ? '0' : row.ordersPF}/{row.tOrdersPF}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
        if (column.id === 'pjOrders') {
            let value = calculatePercentage(row.ordersPJ, row.tOrdersPJ);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.ordersPJ === null ? '0' : row.ordersPJ}/{row.tOrdersPJ}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }

        if (column.id === 'counselor') {
            return (
                <div>
                    <Typography variant="tableContent"> {row.user.name + ' ' + row.user.firstName}</Typography>
                </div>
            );
        }
    };

    const cellModifierNissan = (row, column, value) => {
        if (column.id === 'counselor') {
            return (
                <div>
                    <Typography variant="tableContent"> {row.user.name + ' ' + row.user.firstName}</Typography>
                </div>
            );
        }
        if (column.id === 'totalOrders') {
            let value = calculatePercentage(row.totalsDeliveries, row.tTotalsDeliveries);
            let color = getProcentColor(value);
            return (
                <div>
                    <Typography variant="tableContent">
                        {row.totalsDeliveries === null ? '0' : row.totalsDeliveries}/{row.tTotalsDeliveries}
                    </Typography>
                    <PercentageComponent value={value} color={color} />
                </div>
            );
        }
    };

    const handleFilterData = () => {
        setIsSearch(false);
        setIsFilter(true);
        if (activeTab === 0) setLoadingDacia(true);
        if (activeTab === 1) setLoadingRenault(true);
        if (activeTab === 2) setLoadingNissan(true);

        const newFilterData = {
            ...filterData,
            startDate: dayjs(filterData.startDate).startOf('month').format(),
            endDate: dayjs(filterData.endDate).endOf('month').format(),
            userId: userData.id,
        };
        // if (newFilterData.userId === '') delete newFilterData.userId;

        setFilterData(newFilterData);

        setTriggerFilter(!triggerFilter);

        setOpenFilter(false);
    };

    const filteredSearch = (data) => {
        let filteredData = [];
        if (activeTab === 0) {
            filteredData = data.filter((obj) => obj.brandId === '1');
        }
        if (activeTab === 1) filteredData = data.filter((obj) => obj.brandId === '2');
        if (activeTab === 2) filteredData = data.filter((obj) => obj.brandId === '3');

        return isSearch ? filteredData : null;
    };

    const filterFilter = (data) => {
        let filteredData = [];

        if (activeTab === 0) {
            filteredData = data.filter((obj) => obj.brandId === '1');
        }
        if (activeTab === 1) filteredData = data.filter((obj) => obj.brandId === '2');
        if (activeTab === 2) filteredData = data.filter((obj) => obj.brandId === '3');

        return isFilter ? filteredData : [];
    };

    const tabs = [
        {
            label: 'DACIA',
            id: 0,
            render: true,
            disabled: !existDacia,
            hasUtility: true,
            component: (
                <CustomTable
                    labels={labelsDacia}
                    tableData={currentUserObjectives.filter((objective) => objective.brandId === '1')}
                    cellModifier={cellModifierDacia}
                    withPagination={false}
                    hover={false}
                    withBoxShadow={false}
                    withRowColors={false}
                    loading={loadingDacia}
                    setLoading={setLoadingDacia}
                    filterSearch={filteredSearch}
                    triggerFilter={triggerFilter}
                    filterData={filterData}
                    filterFunction={ObjectivesAPI.filterObjectives}
                    isFilter={isFilter}
                    filterFilter={filterFilter}
                    setterFunction={setCurrentUserObjectives}
                />
            ),
        },
        {
            label: 'RENAULT',
            id: 1,
            render: true,
            disabled: !existRenault,
            hasUtility: true,
            component: (
                <CustomTable
                    labels={labelsRenault}
                    tableData={currentUserObjectives.filter((objective) => objective.brandId === '2')}
                    cellModifier={cellModifierRenault}
                    withPagination={false}
                    hover={false}
                    withBoxShadow={false}
                    withRowColors={false}
                    loading={loadingRenault}
                    setLoading={setLoadingRenault}
                    filterSearch={filteredSearch}
                    triggerFilter={triggerFilter}
                    filterData={filterData}
                    filterFunction={ObjectivesAPI.filterObjectives}
                    isFilter={isFilter}
                    filterFilter={filterFilter}
                    setterFunction={setCurrentUserObjectives}
                />
            ),
        },
        {
            label: 'NISSAN',
            id: 2,
            render: true,
            disabled: !existNissan,
            hasUtility: true,
            component: (
                <CustomTable
                    labels={labelsNissan}
                    tableData={currentUserObjectives.filter((objective) => objective.brandId === '3')}
                    cellModifier={cellModifierNissan}
                    withPagination={false}
                    hover={false}
                    withBoxShadow={false}
                    withRowColors={false}
                    loading={loadingNissan}
                    setLoading={setLoadingNissan}
                    filterSearch={filteredSearch}
                    triggerFilter={triggerFilter}
                    filterData={filterData}
                    filterFunction={ObjectivesAPI.filterObjectives}
                    isFilter={isFilter}
                    filterFilter={filterFilter}
                    setterFunction={setCurrentUserObjectives}
                />
            ),
        },
    ];

    const handleRemoveFilters = () => {
        setFilterData({
            startDate: new Date(),
            endDate: new Date(),
            userId: userData.roleId === '4' || userData.roleId === '5' ? userData.id : '',
        });
        setIsFilter(false);

        if (activeTab === 0) setDaciaObjectives([]);
        if (activeTab === 1) setRenaultObjectives([]);
        if (activeTab === 2) setNissanObjectives([]);

        if (activeTab === 0) setCurrentUserObjectives([]);
        if (activeTab === 1) setCurrentUserObjectives([]);
        if (activeTab === 2) setCurrentUserObjectives([]);

        if (activeTab === 0) setLoadingDacia(true);
        if (activeTab === 1) setLoadingRenault(true);
        if (activeTab === 2) setLoadingNissan(true);
        setTriggerRefetch(!triggerRefetch);
        setOpenFilter(false);
        getObjectivesByUserId();
    };

    return (
        <>
            <Helmet>
                <title>Darex CRM :: {t('User objectives')}</title>
            </Helmet>
            <PageLayout
                withTooltip={true}
                title={`${t('Objectives')} - ${userData?.firstName ? userData.firstName : ''}`}
                backArrow
                actionArea={
                    <>
                        <PrimaryButton startIcon={<FilterListIcon />} color="light" onClick={() => setOpenFilter(true)}>
                            {t('FILTER OBJECTIVES')}
                        </PrimaryButton>
                    </>
                }
            >
                <CustomTableLayout
                    tabs={tabs}
                    setTabName={setTabName}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </PageLayout>

            <CustomDialog
                open={openFilter}
                setOpen={setOpenFilter}
                title={t('Filter objectives')}
                buttonClose={t('Cancel')}
                buttonFinish={t('Finish')}
                width="600px"
                buttonUtility={t('REMOVE FILTERS')}
                onClickButtonUtility={handleRemoveFilters}
                onClickButtonFinish={() => {
                    handleFilterData();
                }}
            >
                <Grid container justifyContent={'space-between'} spacing={4}>
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label={t('Start Date')}
                                views={['month', 'year']}
                                value={filterData.startDate}
                                onChange={(value) => {
                                    handleChange({ target: { name: 'startDate', value } });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        fullWidth
                                        {...params}
                                        sx={{
                                            fieldset: {
                                                borderRadius: '10px',
                                            },
                                        }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label={t('End Date')}
                                views={['month', 'year']}
                                value={filterData.endDate}
                                onChange={(value) => {
                                    handleChange({ target: { name: 'endDate', value } });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        fullWidth
                                        {...params}
                                        sx={{
                                            fieldset: {
                                                borderRadius: '10px',
                                            },
                                        }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    {/* <Grid item xs={12}>
                        <TextField
                            fullWidth
                            select
                            sx={{
                                fieldset: {
                                    borderRadius: '10px',
                                },
                            }}
                            id="outlined-required"
                            label={t('Counselor')}
                            name="counselor"
                            value={filterData.counselor}
                            onChange={handleChange}
                        >
                            {[
                                { id: 1, name: 'Ionut' },
                                { id: 2, name: 'Gabriel' },
                            ].map((user) => (
                                <MenuItem key={user.id}>{user.name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid> */}
                </Grid>
            </CustomDialog>

            <AddObjectivesModal
                open={openAddObjectives}
                setOpen={setAddOpenObjectives}
                tabName={tabName}
                triggerRefetch={triggerRefetch}
                setTriggerRefetch={setTriggerRefetch}
            />

            <ConfirmModal
                open={openConfirm}
                setOpen={setOpenConfirm}
                onClickButtonYes={() =>
                    ObjectivesAPI.delete(rowId).then((res) => {
                        if (res.ok === true) {
                            setTriggerRefetch(!triggerRefetch);
                            setOpenConfirm(false);
                            toast.success(t('The objective was successfully deleted!'));
                        } else {
                            toast.error(t('Something went wrong!'));
                        }
                    })
                }
                text={t('Are you sure you want to delete this objective?')}
            />
        </>
    );
};

export default UserObjectives;
